import { useTranslation } from 'react-i18next';

import STATUS_KEY_BY_STATE from '../constants/toolStatus';

/**
 * What a tool call is doing, in the reader's language, from the state its part is in.
 *
 * Undefined for a state this UI does not know, and for a part with none: the call is then listed
 * by name alone.
 */
const useAiChatToolStatus = (state?: string): string | undefined => {
  const { t } = useTranslation();
  const statusKey = state ? STATUS_KEY_BY_STATE[state] : undefined;

  return statusKey ? t(statusKey) : undefined;
};

export default useAiChatToolStatus;
